import React, { useEffect, useState } from "react";
import "bootstrap/dist/js/bootstrap.bundle";
import "../../../../styles/userManagement.css";
import EditVendor from "./editVendorManagement";
import {Modal} from "@appkit4/react-components/modal"
import ModalFooter from "@appkit4/react-components/esm/modal/ModalFooter";
import PropTypes from 'prop-types';
import APIService from "../../../../services/apiAxiosService";
import useHttp from "../../../../hooks/useHttp";
import {Table, Column} from "@appkit4/react-components/table";
import { Input } from "@appkit4/react-components/field";
import { Pagination } from "@appkit4/react-components/pagination";

function VendorManagement(props) {
  const [vendorId, setVendorId] = useState();
  const [vendorUserId, setVendorUserId] = useState();
  const [modalVisible, setModalVisible] = useState(false);
  const [updateVendorId, setUpdateVendorId] = useState();
  const [editScreen, setEditScreen] = useState(false);
  const [search, setSearch] = useState("");
  const [tableData, setTableData] = useState([]);
  const [filter, setFilter] = useState([]);
  const [current, setCurrent] = useState(1);
  const [totalPage, setTotalPage] = useState(500);
  const { sendRequest: getVendorRecordsById } = useHttp();
  let {
    handleDelete,
    updateVendorDetailsById,
    loading,
    VendorBusinessUnitList,
    VendorSubBusinessUnitList,
    reload,
  } = props;

  const getVendorDetailsById = async (vendorId, vendorUserId) => {
    getVendorRecordsById(APIService.getVendorRecordsById(vendorId, vendorUserId), (result) => {
      if (result) {
        setUpdateVendorId(result.MSG[0]);
        setEditScreen(true);
      }
    })
  };

  const handleBack = () => {
    setEditScreen(false);
    setSearch("");
    reload();
    setTableData(props.Vendors);
    setFilter(props.Vendors);
    let totalPageLength = Math.ceil((props.Vendors.length)/10);
      if (totalPageLength === 0) {
        totalPageLength = 1;
      }
      setTotalPage(totalPageLength);
  };
  const handleCancel = () => {
    setModalVisible(false);
  };
  useEffect(() => {
    setTableData(props.Vendors);
    setFilter(props.Vendors);
    let totalPageLength = Math.ceil((props.Vendors.length)/10);
      if (totalPageLength === 0) {
        totalPageLength = 1;
      }
      setTotalPage(totalPageLength);
  }, [props.Vendors]);

  useEffect(() => {
    const result = tableData?.filter((thirdParty) => {
      return thirdParty.email.toLowerCase().match(search.toLocaleLowerCase());
    });
    setFilter(result);
    let totalPageLength = Math.ceil((result.length)/10);
      if (totalPageLength === 0) {
        totalPageLength = 1;
      }
      setTotalPage(totalPageLength);
  }, [search]);

  if (loading) {
    return (
      <div className="a-loading a-primary a-m-10 a-loading-24 spinner-alignment"></div>
    );
  }

  const sortFuncForOrder1 = (a, b) => {
    const firstOrderId = (a.vendor_name).charAt(1);
    const secondOrderId = (b.vendor_name).charAt(1);
    return firstOrderId > secondOrderId ? 1 : -1;;
}

const sortFuncForOrder2 = (a, b) => {
  const firstOrderId = (a.vendor_name).charAt(1);
  const secondOrderId = (b.vendor_name).charAt(1);
  return firstOrderId < secondOrderId ? 1 : -1;;
}

const renderActionCell = (row) => {
  return(
    <>
      <span className="Appkit4-icon icon-edit-fill action-icon pointer" title="Edit Third Party" onClick={() => handleEditButton(row)}></span> &nbsp;
      <span className=" Appkit4-icon icon-delete-fill action-icon pointer" title="Delete Third Party" onClick={() => handleDeleteButton(row)}></span>
    </>
  )
}

const handleEditButton = (row) => {
  getVendorDetailsById(row?.vendor_id, row?.vendor_user_id);
}

const handleDeleteButton = (row) => {
  setVendorId(row?.vendor_id);
  setVendorUserId(row?.vendor_user_id);
  setModalVisible(true);
}

const renderResponseCell = (row) => {
  let response;
  switch (row.assessment_response) {
    case 1:
      response = "Yes";
    break;
    case 0:
      response = "No";
    break;
    
    default:
      response = "";
  }
  return <div>{response}</div>
}

  return (
    <div className="App">
      {editScreen ? (
        <EditVendor
          handleBack={handleBack}
          updateVendorId={updateVendorId}
          VendorBusinessUnitList={VendorBusinessUnitList}
          VendorSubBusinessUnitList={VendorSubBusinessUnitList}
          updateVendorDetailsById={updateVendorDetailsById}
        />
      ) : (
        <div className="col-lg-12 mt-3 pl-1">
            <div className="ap-table-demo menu-tableAlignment-width">
              {tableData.length > 0 ? (
                <Input
                type="text"
                title= "Search Third Party Contact Email"
                value={search}
                className="ap-field-wrapper-tableSearch"
                onChange={(e) => setSearch(e)}
              /> 
              ) : ""}
            <Table originalData={filter} hasTitle currentPage={current} pageSize={10}>
                <Column field="vendor_name" sortKey={filter.length > 0 ? "vendor_name" : ""} sortFunc1={sortFuncForOrder1} sortFunc2={sortFuncForOrder2}>Third Party Name</Column>
                <Column field="business_unit" sortKey={filter.length > 0 ? "business_unit" : ""}>Business Unit</Column>
                <Column field="sub_business_unit" sortKey={filter.length > 0 ? "sub_business_unit" : ""}>Sub-Business Unit</Column>
                <Column field="contact_name" sortKey={filter.length > 0 ? "contact_name" : ""}>Third Party Contact</Column>
                <Column field="email" sortKey={filter.length > 0 ? "email" : ""}>Third Party Contact Email</Column>
                <Column field="assessment_response"  renderCell={renderResponseCell} sortKey={filter.length > 0 ? "assessment_response" : ""}>Assessment Response</Column>
                <Column field="vendor_id"
                renderCell={renderActionCell}
                >Action</Column>
            </Table>
            {filter.length === 0 ? (
                  <div className="noData">
                  No data available in table
                  </div>
                  ) : ("")}
                <Pagination
                  defaultCurrent={1}
                  current={current}
                  total={totalPage}
                  onPageChange={(page) => setCurrent(page)}
                >
                </Pagination>
            </div>
            </div>
      )}
      <Modal
        className="baseline-modal-showcase"
        visible={modalVisible}
        bodyStyle={{maxHeight:"280px"}}
        footerStyle={{paddingTop:"8px", marginTop:"-8px"}}
        modalStyle={{width:"49.75rem", maxHeight:"fit-content"}}
        onCancel={handleCancel}
      >
        <div className="modal-title">
          Are you sure you want to delete this third party account?
          </div>
        <ModalFooter>
          <button
            type="button"
            className="cancel-button"
            onClick={handleCancel}
          >
            No
          </button>

          <button
            type="submit"
            className="save-button m-l-2"
            onClick={() => handleDelete(vendorId, vendorUserId, setModalVisible, setSearch)}
          >
            Yes
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

VendorManagement.propTypes = {
  Vendors: PropTypes.any,
  handleDelete: PropTypes.func,
  updateVendorDetailsById: PropTypes.func,
  loading: PropTypes.any,
  VendorBusinessUnitList: PropTypes.any,
  VendorSubBusinessUnitList: PropTypes.any,
  reload: PropTypes.any,
}

export default VendorManagement;
